import { IoWarningOutline } from "react-icons/io5";
import { Button } from "@/components/ui/button";

type FallbackScreenProps = {
  onReload: () => void;
};

export const FallbackScreen = ({ onReload }: FallbackScreenProps) => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
      <IoWarningOutline className="text-3xl text-red-500" />
    </div>
    <h1 className="text-lg font-semibold text-gray-800">Algo deu errado</h1>
    <p className="max-w-sm text-sm text-gray-500">
      Encontramos um problema inesperado. Tente recarregar a página — se o
      erro continuar, entre em contato com o suporte.
    </p>
    <Button variant="primary" size="md" onClick={onReload}>
      Recarregar
    </Button>
  </div>
);
